export const timeEn = {
  availability: {
    'all-day': 'Available all day',
    'not-available': 'Not available',
  },
  closed: 'Closed',
  days: {
    long: {
      friday: 'Friday',
      monday: 'Monday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      thursday: 'Thursday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
    },
    short: {
      friday: 'Fri',
      monday: 'Mon',
      saturday: 'Sat',
      sunday: 'Sun',
      thursday: 'Thu',
      tuesday: 'Tue',
      wednesday: 'Wed',
    },
  },
  open24: 'Open 24hrs',
  'recurrence-interval': {
    day: 'Daily',
    hour: 'Hourly',
    month: 'Monthly',
    week: 'Weekly',
    year: 'Annually',
  },
  'validation-errors': {
    'overlapping-intervals': 'Hours must not overlap',
    'zero-length': 'Start and end times must be different',
  },
}
